import { Component, EventEmitter, Input, Output, type OnInit } from '@angular/core'
import { AIService, AITone } from '@tokeet-frontend/ai'
import { AuthService } from '@tv3/services/auth.service'
import { finalize } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'
import { CdkOverlayOrigin } from '@angular/cdk/overlay'

@Component({
  selector: 'app-ai-suggestions-icon',
  templateUrl: './ai-suggestions-icon.component.html',
  styles: [
    `
      :host {
        display: inline-block;
      }
    `,
  ],
})
export class AiSuggestionsIconComponent implements OnInit {
  @Input() attachTo: CdkOverlayOrigin
  @Input() entityId: string
  @Input() type:
    | 'charge_description'
    | 'expense_description'
    | 'incident_description'
    | 'inventory_description'
    | 'rental_description'
    | 'rental_house_rules'
    | 'rental_checkin'
    | 'rental_checkout'
    | 'task_description' = 'rental_description'
  @Input() tone = AITone.Business
  @Input() count = 3
  @Input() length = 500
  @Input() width = 300
  @Input() minWidth = 300

  @Input() tooltipText = $localize`Generate suggestions for the description`

  @Output() apply = new EventEmitter<string>()

  isDropdownOpen = false
  isLoading = false

  toneOptions = Object.values(AITone)

  suggestions: string[] = []
  selectedSuggestionIndex = 0

  constructor(private aiService: AIService, private auth: AuthService, private store: Store<any>) {}

  ngOnInit(): void {}

  onShow() {
    this.isDropdownOpen = true
    if (!this.suggestions?.length && !this.isLoading) {
      this.onGenerate()
    }
  }

  onGenerate() {
    this.isLoading = true
    this.isDropdownOpen = true
    this.selectedSuggestionIndex = 0
    this.aiService
      .suggestions({
        account: String(this.auth.accountId),
        type: this.type as any,
        id: this.entityId,
        count: this.count,
        tone: this.tone,
        length: this.length,
      })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (res) => {
          this.suggestions = res
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onRefresh() {
    this.onGenerate()
  }

  onShorten() {
    this.length -= 100
    if (this.length < 100) {
      this.length = 100
    }
    this.onGenerate()
  }

  onExpand() {
    this.length += 200
    this.onGenerate()
  }

  onTone(tone: AITone) {
    this.tone = tone
    this.onGenerate()
  }

  onPrevious() {
    this.selectedSuggestionIndex =
      (this.selectedSuggestionIndex - 1 + this.suggestions.length) % this.suggestions.length
  }

  onNext() {
    this.selectedSuggestionIndex = (this.selectedSuggestionIndex + 1) % this.suggestions.length
  }

  onApply(suggestion: string) {
    this.apply.emit(suggestion)
    this.isDropdownOpen = false
  }
}
